/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_KickerInputs */

const en_road_dude_prompt_kicker = /** @type {(inputs: Road_Dude_Prompt_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THE PROMPT KIT`)
};

const zh_road_dude_prompt_kicker = /** @type {(inputs: Road_Dude_Prompt_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提示词工作台`)
};

/**
* | output |
* | --- |
* | "THE PROMPT KIT" |
*
* @param {Road_Dude_Prompt_KickerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_kicker = /** @type {((inputs?: Road_Dude_Prompt_KickerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_KickerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_kicker(inputs)
	return zh_road_dude_prompt_kicker(inputs)
});
export { road_dude_prompt_kicker as "road_dude.prompt.kicker" }